const React = require('react');
const noop = require("mn-utils/noop");
const AdminCellBase = require('../HeadCellAdminWrapper');
const Ripple = require("../../../../../Ripple");

module.exports = ({children, self = {}, sortName, className, hasScroll, ...props}) => {

  const sort = (self.state || {}).sort || {};
  const onSort = self.onSort || noop;

  const isActiveSort = sortName === sort.name;

  return (
    <AdminCellBase
      {...props}
      className={
        `(w26|h100%|abs|sr-1|st0|layoutRow|jcC|aiC|bg2C2D30)>.sortBtn (fill73757A)>.sortBtn>svg 
        (fillF|dn).activeSort>.sortBtn>svg (xRz180).activeSort.asc>.sortBtn>svg`
        + (className ? ` ${className}` : '')
        + (isActiveSort ? ` activeSort ${sort.type || ''}` : '')
        + (hasScroll ? ' hasScroll' : '')
      }
    >
      <span>{children}</span>
      {sortName && (
        <Ripple className="sortBtn" onClick={() => onSort(sortName)}>
          <svg width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.25 8L-5.34503e-08 9.2228L5 14L10 9.2228L8.75 8L5 11.6L1.25 8Z" />
            <path d="M0 4H10V6H0V4Z" />
            <path d="M0 0H10V2H0V0Z" />
          </svg>
        </Ripple>
      )}
    </AdminCellBase>
  )
}
